import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiService } from '../api.service';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  form:any = {};

  mess:any;

  forgot = false;

  today = new Date();

  @Input() fromAdmin:any;

  @Output() isInit = new EventEmitter();

  constructor(public api:ApiService) { }

  ngOnInit(): void {
    if(localStorage.getItem("EspaceProBlackrockUser") && this.api.adminOrder === false){
      this.form = JSON.parse(localStorage.getItem("EspaceProBlackrockUser"));
      this.send();
    }else{
      this.api.fromGuard = false;
    }
    if(this.api.pro === false){
      this.init();
    }

    if(this.api.adminOrder && this.fromAdmin){
      this.form.fromAdmin = true;
      this.form.email = this.fromAdmin.Id;
      this.send();
    }
  }

  send(){
    this.mess = undefined;
    this.api.post("pro=login",this.form).then((res:any)=>{
      this.api.user = res.user;
      this.mess = res.mess;
      if(this.api.user){
        if(this.form.remember){
          localStorage.setItem("EspaceProBlackrockUser",JSON.stringify(this.form));
        }
        this.api.order.customer = this.api.user;
        this.init();
      }else{
        this.api.fromGuard = false;
      }
    });
  }

  customers:any;

  checkAddress(){
    this.mess = undefined;
    this.api.post("pro=checkAddress",this.form).then((res:any)=>{
      this.customers = res;
    });
  }

  newPass(row){
    this.mess = undefined;
    this.api.post("pro=newPass",row).then((res:any)=>{
      if(res = 'ok')
        this.api.success('Vous avez reçu un mail avec votre nouveau mot de passe');
    });
  }

  init(){
    let userId = this.api.user ? this.api.user.Id : null;
    let exportParam = this.api.adminUser.value ? this.api.adminUser.value.export : (this.api.export ? '1' : '');
    forkJoin([
      this.api.getEncrypted("pro=syncCatalog&CustomerId=" + userId + "&fromPro=" + this.api.pro + "&adminOrder=" + this.api.adminOrder + "&export=" + exportParam),
      this.api.postEncrypted("pro=syncOffers",{}),
      this.api.postEncrypted("pro=syncPrefs",{customerId: userId}),
      this.api.postEncrypted("pro=syncAlerts",{customerId: userId}),
    ]).subscribe(([res1, res2, res3, res4]:any) => {

      if(this.api.isDevMode()) {console.log(res1);}

      this.api.reducsDetails = res1.reducsDetails;


      if(this.api.user && this.api.user.freeShipping && this.api.user.freeShipping == true){
        // En édition de devis, conserver freeShipping du JSON
        if(!this.api.order.edit){
          this.api.order.freeShipping = true;
        }
      }

      if(this.api.user && this.api.user.conditions){
        if(!this.api.order.edit){
          this.api.order.DiscountRate = parseFloat(this.api.user.conditions.discountRateGlobal);
        }
      }

      if(this.api.user && this.api.user.TerritorialityId && res1.tvas && res1.tvas[this.api.user.TerritorialityId]){
        this.api.order.tva = parseFloat(res1.tvas[this.api.user.TerritorialityId].Rate);
      }

      this.api.offers = res2.data.filter(item=>{
        item.acceptedForProds = [];
        if(this.api.user && this.api.user.conditions){
          return this.api.user.conditions.offer_excluded.split(',').map(item=>parseInt(item)).indexOf(item.id_offer) === -1;
        }
        return true;
      });
      
      this.api.cats = res1.cats;

      let ids_editor = [];
     
      this.api.games = res1.jeux.filter(game =>{
        
        if(!this.api.pro && game.name_item){
          game.name = game.name_item.replace('Localized version', '');
        }


        if(this.api.user && this.api.pro && this.api.user.xx_Espace_Pro != 'gss' && game.familyId == 'FAR00076')
          return false;

        if(this.api.user && this.api.pro && this.api.user.xx_Espace_Pro == 'gss' && game.xx_Jeux_catalogue_GSS != '1')
          return false;

        if(!this.api.pro && (game.ItemType != 0 || game.active != 1))
          return false;

        if(this.api.user && this.api.user.conditions && this.api.user.conditions.editor_excluded.split(',').map(item=>parseInt(item)).indexOf(game.ptt_to_editor) > -1){
          return false;
        }

        if(this.api.user && this.api.user.conditions && this.api.user.conditions.item_excluded && this.api.user.conditions.item_excluded.split(',').indexOf(game.Id) > -1){
          return false;
        }

        if(this.api.export && game.export == 0){
          return false;
        }else{
          //console.log(game);
        }
        ids_editor.push(game.ptt_to_editor);
        return true;
      });
      //console.log(ids_editor);
      this.api.editors = res1.editors.filter(item => { 
        if(this.api.user && this.api.user.conditions && this.api.user.conditions.editor_excluded.split(',').map(item=>parseInt(item)).indexOf(item.id) > -1){
          return false
        }
        return ids_editor.indexOf(item.id) > -1 ;
      });
     // console.log(this.api.editors);

      this.api.shippings = res1.shipping;

      this.api.payment = res1.payment;
      if(this.api.user){
        // En édition de devis, conserver le mode de règlement du JSON
        if(!this.api.order.edit){
          this.api.order.payment.Id = this.api.user.SettlementModeId;
        }
        if(this.api.user.FamilyId == 'FCL00029'){
          this.api.franco = 300;
        }
      }
      this.api.texts = res1.texts;

      this.api.reductions = {};

      this.api.games.forEach(item=>{  
        
        if(item.ItemType == 1)
          item.active = 1;

        item.orderable = true;

        item.out_date_date = new Date(item.out_date);

        if(item.out_date_date < this.today){
          item.out_date_format  = new Date(item.out_date);
        }else{
          item.out_date_format = null;
          let d = moment(item.out_date_date).subtract(7,'days').set({'hour': 18, 'minute': 0 });
          item.orderable = false;
          if(d < moment(this.today))
            item.orderable = true;
        }


        item.rupture = false;

        if(((parseInt(item.RealStock) < 5) && item.out_date_date <= this.today && item.ItemType == '0') || item.force_outstock == '1'){
          item.rupture = true;
          item.orderable = false;
        }

        if (parseInt(item.RealStock) < 5 && item.ItemType == '0') {
          item.orderable = false;
        }


        item.discountRateCustomer = this.api.user ? this.api.user.discountRateCustomer : 40;

        item.discountRateSupp = item.discountRateSupp || 0;
        item.discountRate = (100 - ((1- (item.discountRateCustomer/100) ) * (1- (item.discountRateSupp/100)) *100)).toFixed(2);

          //console.log(item.discountRate);
          item.inStock = !item.rupture;


        item.reassort_suscribed = false;
        if(res4.data.findIndex(row=> item.Id == row.ItemId) > -1)
          item.reassort_suscribed = true;

        item.age_ = (item.age_min == null ? 0 : item.age_min)+"_"+(item.age_max == null ? 99 : item.age_max);
        item.player_ = (item.player_min == null ? 0 : item.player_min)+"_"+(item.player_max == null ? 99 : item.player_max);

        item.editors = [item.ptt_to_editor];
        item.cats = item.cats.split(",").map(item=>parseInt(item));
        item.cats.push(item.cat_princ);
        item.authorizedOffers = [];
      
      for(let o of this.api.offers){
        if(o.excludedIds.indexOf(item.Id) > -1){
          //console.log(o);
          continue;
        }

        let forIds = o.forIds !=  null && o.forIds !=  '' ? o.forIds.split(",") : [];

        if(o.imposed && o.type == 'add' && (o.excluded == '' || o.excluded == null) && (o.included == '' || o.included == null) && forIds.length == 0){
          
          item.authorizedOffers.push(o.id_offer);   
        }else if(forIds.length > 0){
          if(forIds.indexOf(item.Id) > -1){
            //console.log(item.Id);
            item.authorizedOffers.push(o.id_offer); 
            if(o.visual != null){
              item.PriceListId = o.id_offer;
            } 
          }
        }else{
          let excludedConditions = [];
          try{
            if(o.excluded != '' && o.excluded != null)
              excludedConditions = JSON.parse(o.excluded.trim());
          }catch(error){
            console.log(o);
            console.log(error);
          }
          
          let excluded = 0;

          if(excludedConditions.length > 0){
            for(let e of excludedConditions){      
              if(eval(`item[e.property]`+ " "+e.expression)){
                excluded ++;
              }
            }
          }
          
          if(excluded === 0 || (excluded > 0 && excluded < excludedConditions.length)){
            item.authorizedOffers.push(o.id_offer);
            if(o.visual != null){
              item.PriceListId = o.id_offer;
            }       
          }
          
        }

      }

      if(item.PriceListId){
        if(this.api.reductions[item.PriceListId])
          this.api.reductions[item.PriceListId].push(item);
        else
          this.api.reductions[item.PriceListId] = [item]; 
      }

      //this.api.reductions.sort((a,b)=> a.);
    });

    this.api.cacheGames = this.api.parse(this.api.stringify(this.api.games));

    let gamesInRupture = this.api.games.filter(item => item.rupture).map(item => "'"+item.Id+"'").join(",");
    
    this.api.post("pro=checkReassort",{Ids:gamesInRupture}).then((res:any)=>{
      this.api.reassorts = res;
    });

    this.api.reductions = Object.keys(this.api.reductions).sort().reduce((result, key) => {
      
      if(!this.api.user || !this.api.user.conditions || this.api.user.conditions.offerEbp_excluded.split(',').indexOf(key) === -1){
        result[key] = this.api.reductions[key];
      }
      return result;
    }, {});


      this.api.ebpOffers = res1.ebpOffers.filter(item=>{
        for(let link of item.linked){
          let find = this.api.games.find(item1 => item1.Id == link.LinkedItemId);
          if(!find){
            //console.log(item.Id+" - "+link.LinkedItemId);
            return false;
          }
        }

        if(this.api.user && this.api.user.conditions && this.api.user.conditions.offerEbp_excluded.split(',').indexOf(item.Id) > -1)
          return false;

        let game = this.api.games.find(item2 => item.Id == item2.Id);
        
        if(game && game.PriceListId)
          item.hidden = true;

        if(game && (game.image_princ || item.image_princ)){
          item.image_princ = game.image_princ || item.image_princ;
          item.id_item = game.id_item;
          return true; 
        }
        return false;
      }).sort((a,b) => b.Id.localeCompare(a.Id));



      this.api.favs = res3.data;
      if(this.api.adminOrder === false){
        if(this.api.pro)
          this.api.goTo(localStorage.getItem("EspaceProBlackrockPage") || "home");
        else
          this.api.goTo(this.api.fromLink);
      }

      try{
        if(localStorage.getItem('brgProOrder') && this.api.pro && !this.api.adminOrder){
          let order = JSON.parse(localStorage.getItem('brgProOrder'));
          if(order.prods && order.prods.length > 0){
            this.api.order.prods = order.prods;
            for(let p of this.api.order.prods){
              if(p.parent === undefined){
                let g =  this.api.games.find(item => item.Id == p.Id);
                if(g)
                  g.idInCart = p.id;
              }
            }
            const unavailable = this.api.revalidateCartAvailability();
            this.api.totalOrder();
            if(unavailable.length > 0){
              const names = unavailable.map(p => p.name || p.Id).join(', ');
              this.api.warning(
                'Certains articles de votre panier ne sont plus disponibles : ' + names +
                '. Ils apparaissent en rouge : retirez-les ou ajustez avant de commander.'
              );
              try{
                localStorage.setItem('brgProOrder', JSON.stringify(this.api.order));
              }catch(e){}
            }
          }
          else
            localStorage.removeItem('brgProOrder');
        }
      }catch(e){
        console.log(e);
      }
      this.api.fromGuard = false;

      this.isInit.emit();
    });


}
}
